var _circle, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 43,
    fill: "none",
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.658,
    cy: 21.429,
    r: 20.82,
    fill: "#fff",
    fillOpacity: 0.06
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 11,
    height: 19,
    x: 16,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M16.8 12.407h9.842v18.044H16.8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.8 12.407h9.842v18.044H16.8z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "matrix(.00342 0 0 .00195 -.375 0)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAMAAABrrFhUAAAAJFBMVEVMaXEBAAIAAAAAAAEBAAEAAAAAAAEAAAABAAEBAAEAAAABAALjDCjxAAAAC3RSTlMA/AJKyjV6BqbkIHuZ+tAAAAAJcEhZcwAALa4AAC2uAWcIerIAAAO/SURBVHja7dzbbuQgDIBhDkmA8P7vu2RGrapudztkEhnj3zcrrdQLfwFDMgbnxokUnv/sa9xyXpZSiq/e+/KIpUXOeWsRY1z3lNxU8cg+7S31lvXf8f3/DpblwRH3CbIPj+xjXvxnfi2+p/wlvspsTvtYOLLfYy4fedbX4sNCO8CR/pr9I6PaH9oBwjH0j5F/Knv1AG3up638UOOMALTHH5fzD187QHv867vpawYILmz+3fQVAwS3L++nrxcguFjq++lrBWjTf7vi8WsFaItfvih/lQDP6V+rVYBL81cI0Mb/hflrHAHH/K92AYK7NH91AI/1r9oFSC5em78ygLYAFNMA7uICoA3g8gKgDKBNgKvT1wZw+QRQBdDegGs1PQLcUi1PgXD5FkDdFFhMA9xTAVQB5DsGgBqA9huANz0C7tgE6poCqVTLI+CuEqgI4J4SqGcKpGIa4L4ZoAbgpjVATw14axvs/xc6AE5/Cfm1aUwFwOkS8Ez+6BJ9toj+GKsL438MP1UCjj8peVtTCr81WU65C2j9MzmmzzTTvyJMugvwNa9H5ioSvP5rcHv8m47h/dqrcH/+ZZ0l/XNfA/3q5jkP0L8IzNAD/85GuNU/F9xM0bsK+nUugM43AV8XN1d0bgMmqwAnvgf6fbIS0Acw3wxwyVfTM6BzJzwdQP+rQJxsEez9VWy2GtgNUCarAAD0AXgAFvMAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhrsW74VI/b8Nthbxl2PGEaBndO/xpdg6G8VjTzh1J2GuPTS3WAeQbKseAkCypQ4AeQDZnsIRAER7CkcAEO0okwcQ7igbASA78wDBNoBoZ/0IANE2gPDRghF2grtxANnGcnEA6a9nAwCIbgPGAAi2AWQP2A0AEG2PgFpX4wB+t10Epc+XSQOI/4QiDyB81Yg8gPAxcwDEi2B0xt8FVusAu+lVQP6YuTiAdCeFOID0jWPiANK3zQAgvQpE21NA/rodaQDxy1ZkAQa4bEUaIDvzAME2gPilc9IA0TbAALfuSe8EB7h177Vu8fWmbvE07YkR5zgxMsdZEQ5NAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACciD+VK9ImNoTq3gAAAABJRU5ErkJggg==",
    id: "c",
    width: 512,
    height: 512
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.e9b6bad5905705a0e8558f82081c0268.svg";
export { ForwardRef as ReactComponent };